import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { AccountResponse } from '../models/account.model';
import { NomenclatureAccountRequest, NomenclatureAccountResponse } from '../models/nomenclature.model';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  private url = environment.api;
  constructor(
    private http: HttpClient,
  ) { }

  getAccounts() {
    return this.http.get(this.url + "api/erp/bank/accounts");
  }

  getCashs() {
    return this.http.get(this.url + "api/erp/bank/cashs?active=true");
  }

  getAccountsLevel4() {
    return this.http.get(this.url + "api/erp/accounts/level/4");
  }

  getAccountsLevel3() {
    return this.http.get(this.url + "api/erp/accounts/level/3");
  }

  saveAccount(newAccount: AccountResponse) {
    return this.http.post(this.url + "api/erp/bank/account", newAccount);
  }

  getAccountOptions() {
    return this.http.get(this.url + "api/erp/bank/accountoptions");
  }

  putAccount(idUpdated: number, updatedAccount: AccountResponse) {
    return this.http.put(this.url + "api/erp/bank/account/" + idUpdated, updatedAccount);
  }

  activeOrInactive(id: number) {
    return this.http.delete(this.url + "api/erp/bank/account/" + id);
  }

  saveTransferCashBank(request: any) {
    return this.http.post(this.url + "api/erp/bank/localtransfer", request);
  }

  getAccountsCompany(company, isPartner = false) {
    const headerDict = {
      "inin-company": company
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.get(this.url + `api/erp/bank/accountsCompany${isPartner ? 'Admin' : ''}/${company}`, requestOptions);
  }

  getCashBanks(company) {
    const headerDict = {
      "inin-company": company
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
    };
    return this.http.get(this.url + `api/erp/bank/cashsBanks?active=true&company=${company}`, requestOptions)
  }

  //api/erp/bank/banksUpload
  saveRegisters(company, bank, bankRequest) {
    const headerDict = {
      "inin-company": company
    }
    const requestOptions = {
      headers: new HttpHeaders(headerDict),
      params: {
        company: company,
        banco: bank
      }
    };
    return this.http.post(this.url + `api/erp/bank/banksUpload`, bankRequest, requestOptions);
  }

  getGoalsBudget() {
    return this.http.get(this.url + "api/erp/accounts/budgetgoals");
  }

  deleteAccount(accountId: number) {
    return this.http.delete(this.url + `api/erp/accounts/${accountId}`);
  }

  createOrEditAccount(account: NomenclatureAccountRequest, isEdit) {
    if (isEdit) {
      return this.editAccount(account);
    } else {
      return this.createAccount(account);
    }
  }

  createAccount(newAccount: NomenclatureAccountRequest){
    return this.http.post(this.url + "api/erp/accounts", newAccount);
  }

  editAccount(account: NomenclatureAccountRequest) {
    return this.http.put(this.url + `api/erp/accounts/${account.parentId}`, account);
  }
}
